import { FieldFilter } from 'module/types/filter-field/filter';
import { GroupedFilter } from 'module/types/filter-field/grouped-filter/filter';
import { FC, useMemo } from 'react';
import { AsBadgesBase, AsBadgesBaseProps } from './as-bagdes-base';

interface Props extends AsBadgesBaseProps {
  filter: GroupedFilter;
}

export const GroupedFilterAsBadges: FC<Props> = ({ filter, ...rest }) => {
  const criteria = useMemo(() => {
    return filter.groupCriteria.map(({ criteria: x }) => x);
  }, [filter.groupCriteria]);

  return <AsBadgesBase criteria={criteria as FieldFilter[]} {...rest} />;
};
